const t = {
  "cdr-container": "cdr-container_15-4-1",
  "cdr-container--static": "cdr-container--static_15-4-1"
};
export {
  t as default
};
